
<div class="container-fluid" style="padding-left: 10px;">
    <div class="row ">
        <!-- Header -->
        <div class="col-12 col-md-12 bgWhite padHeder mobView ">
            <div class="col-10 col-md-6 pad0" style="display: inline-block;vertical-align: sub;">
            <span style="font-size: 20px; margin-right: 10px;" (click)="back()">
                <i class="fa fa-chevron-left"></i>
            </span>
            <h4 class="newHeader" style="display: inline-block; font-family: 30px;">Rejection Reasons</h4>
            </div>
            <div class="col-2 col-md-6 pad0" style="display: inline-block;">
            <!-- <span style="float: right;">
                <span class="label" (click)="open(mymodal,0)"
                      style="border-radius: 50%; position: relative; top: 5px; cursor: pointer; bottom: 5px; padding: 12px; font-size: 11px; background:#e88421 !important; color:#fff !important">
                    <i class="zmdi zmdi-plus" aria-hidden="true" style="font-size: 19px; vertical-align: sub;"></i>
                </span>
            </span> -->
        </div>
        </div>
       
        <div class="col-md-12 bgWhite webView"  style="padding: 16px 29px 15px 30px">
            <div class="col-md-5" style="padding: 0px;display: inline-block;">
                <h3 class="newHeader" style="display: inline-block; font-size: 30px;">
                    Rejection Reasons
                </h3>
                <!-- <span style="">
                    <span class="label" (click)="open(mymodal,0)" title="Add New Reason"
                          style="border-radius: 50%; position: relative;cursor: pointer; top: 5px; cursor: pointer; bottom: 5px; padding: 10px; font-size: 11px; background:#e88421 !important; color:#fff !important">
                        <i class="zmdi zmdi-plus" aria-hidden="true" style="font-size: 19px; vertical-align: sub;"></i>
                    </span>
                </span>   -->
            </div>
            <!-- <span style="">
                <span class="btn btn-teal" (click)="open(mymodal,0)" title="Add New Reason"
                      style="border-radius: 50%; position: relative;cursor: pointer; top: 5px; cursor: pointer; bottom: 5px; padding: 10px; font-size: 11px; background:#e88421 !important; color:#fff !important">
                    <i class="zmdi zmdi-plus" aria-hidden="true" style="font-size: 19px; vertical-align: sub;"></i>
                    <span> Add</span>
                </span>
            </span>   -->
            <div class="col-md-7 col-sm-7" style="display: inline-block; text-align: right; padding: 0px;">
                <span class="orangeButton brdrRadius3" (click)="open(mymodal,0)" title="Add New Reason"
                      style="padding:4px 12px 4px; font-size:13px;">
                      <span style="margin-right: 5px;"><i class="zmdi zmdi-plus"></i></span>
                      <span> Add</span>
                </span>
           
                <span class="darkBlueButton brdrRadius3" style="font-size: 13px; margin-left: 10px; padding: 4px 12px 4px; float: right;" (click)="backBtn()">
                    <i class="fa fa-chevron-left" style="margin-right: 3px;"></i> Return to Production
                </span>
            </div>     
        </div>
       
        <!-- Reasons List -->
        <div *ngIf="reasons.length > 0" class="col-md-12 col-12 col-sm-12 leftPad webView">
        <div class="col-md-5 col-12 col-sm-12" style="padding: 0px;">
            <div *ngFor="let r of reasons let i = index" class="col-md-12 col-12 col-sm-12 orangeBadge brdrRadius3" style="padding-top: 8px; 
            padding-bottom: 8px;margin-bottom: 10px; border: 1px solid; display:inline-flex; background-color: white;">
                <div class="col-md-9 col-9 col-sm-9" style="font-size: 13px; display: inline-block;padding: 0px;">
                    <span style="vertical-align: middle;">{{r.Rsn}}</span>
                </div>
                <div class="col-3 col-sm-3" style="text-align: right;display: inline-block;">
                    <div class="lableBtnOrange" style="margin-right: 10px; font-size: 13px; display: inline-block; cursor: pointer;" title="Edit" (click)="open(mymodal,r.RID)">
                        <i class="fa fa-pencil" aria-hidden="true"></i>
                    </div> 
                    <div class="lableBtnGray" style="display: inline-block;cursor: pointer;font-size: 13px;" title="Delete" (click)="deleteReason(i)">
                        <i class="fa fa-trash"></i>
                    </div>                                  
                </div>
            </div>
        </div> 
        </div>

        <div *ngIf="reasons.length > 0" class="col-md-12 col-12 col-sm-12 leftPad mobView">
            <div class="col-md-5 col-12 col-sm-12">
                <div *ngFor="let r of reasons let i = index" class="col-md-12 col-12 col-sm-12 orangeBadge bgWhite brdrRadius3 orangeBrdr " style="padding-top: 10px; 
                    padding-bottom: 10px; margin-bottom: 5px; display:inline-flex; background-color: white !important;">
                    <div class="col-md-9 col-9 col-sm-9" style="font-size: 13px;display: inline-block;padding: 0px;">
                    <span>{{r.Rsn}}</span>
                    </div>
                    <div class="col-3 col-sm-3" style="text-align: right;display: inline-block;">
                        <div style="margin-right: 15px; font-size: 13px; display: inline-block; cursor: pointer;" title="Edit" (click)="open(mymodal,r.RID)">
                            <i class="fa fa-pencil" aria-hidden="true"></i>
                        </div> 
                        <div style="display: inline-block;cursor: pointer;font-size: 13px;" title="Delete" (click)="deleteReason(i)">
                            <i class="fa fa-trash"></i>
                        </div>                                  
                    </div>
                </div>
            </div> 
            </div>
        <div class="bgWhite" style="padding-top: 15px;padding-left: 30px;cursor: pointer;" *ngIf="reasons.length == 0">
            <div class="nrf brdrRadius3" (click)="open(mymodal,0)">
                Click here to add a reason.
            </div>
        </div> 
     </div>
</div> 

<!--Add reason-->
<ng-template #mymodal let-modal>
    <!--Header-->
    <div class="modal-header" style="border-bottom: none;">
        <div class="col-md-12 col-12 col-xs-12">
            <div class="row">
                <div class="col-md-9 col-10 col-xs-10" style="padding-left: 0px;">
                    <h4 class="modal-title"><span id="ApntmntHdr" style="font-size: 22px;">{{isEdit == false ? 'Add Reason' : 'Edit Reason'}}</span></h4>
                </div>
                <div class="col-md-3 col-2 col-xs-2" style="padding: 0px;">
                    <i class="closeMdl zmdi zmdi-close " style="float: right;" (click)="closeModal()" ></i>                       
                </div>
            </div>              
        </div>
    </div>
    <!--Body-->
    <div class="modal-body" style="padding: 0px;">
        <div class="col-md-12" style="padding: 0px 15px 0px 15px;">
            <div class="col-md-12 col-xs-8 col-8" style="padding: 0px 15px 10px 0px;display: inline-block;">
                <input type="text" [(ngModel)]="reason" class="form-control" maxlength="30" style="text-indent: 2px;" placeholder="Enter Reason">
            </div>
        </div>
        <div class="col-md-12" style="padding: 0px 15px 15px 15px;">
            <div class="col-md-5 col-xs-8 col-8" style="padding: 0px 15px 10px 0px;display: inline-block;">
                <input type="text" [(ngModel)]="code" class="form-control" maxlength="15" style="text-indent: 2px;" placeholder="Enter code">
            </div>
        </div>
        <div class="col-md-12 col-xs-12 col-12" style="display: inline-block; padding: 0px 0px 15px 15px;">
            <span class="btn-green brdrRadius3" style="padding: 0px 10px; font-size: 14px; line-height: 30px;" (click)="isEdit == false ? addReason(reason,code) : editReason(reason,code)" >
                <i class="fa fa-check" style="margin-right: 5px; "></i>
                <span>Save</span>
            </span>            
        </div>
    </div>
</ng-template>
